import React from 'react';
import ReactDOM from 'react-dom/client';

import { Analytics } from '@vercel/analytics/react';
import { PostHogProvider } from './providers/PostHogProvider';
import { ThemeProvider } from './contexts/ThemeContext';
import './i18n';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <PostHogProvider>
            <ThemeProvider>
                <App />
            </ThemeProvider>
        </PostHogProvider>
        <Analytics />
    </>
);
